import { NavLink, useLocation } from "react-router-dom";
import { Camera, ClockCounterClockwise, Package, User, Coins } from "@phosphor-icons/react";
import { APP_VERSION } from "@/lib/version";

const navItems = [
  { path: "/scan", label: "Scan", icon: Camera, isFab: true },
  { path: "/history", label: "History", icon: ClockCounterClockwise },
  { path: "/ledger", label: "Ledger", icon: Coins },
  // Hauls hidden in iter_45 — keep route at /__hidden/hauls so we can re-enable.
  // { path: "/hauls", label: "Hauls", icon: Package },
  { path: "/profile", label: "Profile", icon: User },
];

export default function BottomNav() {
  const location = useLocation();

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 border-t-4 border-black bg-white flex items-center justify-around h-20 z-[9999] pb-safe"
      data-testid="bottom-nav"
      style={{ zIndex: 10000 }}
    >
      {navItems.map((item) => {
        const isActive = location.pathname.startsWith(item.path);
        const Icon = item.icon;

        if (item.isFab) {
          return (
            <NavLink
              key={item.path}
              to={item.path}
              className="relative -top-6"
              data-testid="nav-scan-fab"
            >
              <div
                className={`h-20 w-20 rounded-full border-4 border-black flex items-center justify-center shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] transition-all active:translate-x-[2px] active:translate-y-[2px] active:shadow-[0px_0px_0px_0px_rgba(0,0,0,1)] ${
                  isActive ? "bg-[#002FA7]" : "bg-black"
                }`}
              >
                <Icon size={32} weight="bold" className="text-white" />
              </div>
              <span className="block text-center text-xs font-body font-semibold tracking-[0.1em] uppercase mt-1">
                {item.label}
              </span>
            </NavLink>
          );
        }

        return (
          <NavLink
            key={item.path}
            to={item.path}
            className="flex flex-col items-center justify-center gap-1 py-2 px-4"
            data-testid={`nav-${item.label.toLowerCase()}`}
          >
            <Icon
              size={24}
              weight={isActive ? "bold" : "regular"}
              className={isActive ? "text-black" : "text-neutral-400"}
            />
            <span
              className={`text-xs font-body font-semibold tracking-[0.1em] uppercase ${
                isActive ? "text-black" : "text-neutral-400"
              }`}
            >
              {item.label}
            </span>
          </NavLink>
        );
      })}
      <span className="absolute bottom-1 right-2 font-body text-[9px] text-neutral-300 select-none" data-testid="app-version">v{APP_VERSION}</span>
    </nav>
  );
}
